import  { useState } from 'react';
import { motion } from 'framer-motion';
import AnimatedProductCard from './AnimatedProductCard';
import { products } from '../data';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const tabs = ['All', 'New Arrivals', 'Best Sellers', 'Featured'];

const FeaturedProducts = () => {
  const [activeTab, setActiveTab] = useState('Featured');
  const [ref, isInView] = useIntersectionObserver<HTMLDivElement>({ threshold: 0.1, once: true });
  
  const filteredProducts = products.filter(product => {
    if (activeTab === 'All') return true;
    if (activeTab === 'New Arrivals') return product.new;
    if (activeTab === 'Best Sellers') return product.bestSeller;
    if (activeTab === 'Featured') return product.featured;
    return true;
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  return (
    <section ref={ref} className="py-16 bg-beige-light">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="font-serif text-3xl text-center mb-2">Our Collection</h2>
          <p className="text-center text-gray-600 mb-8">Timeless pieces crafted with precision</p>
        </motion.div>
        
        <motion.div 
          className="flex flex-wrap justify-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {tabs.map((tab, index) => (
            <motion.button
              key={tab}
              className={`px-4 py-2 mx-2 text-sm font-medium uppercase tracking-wider transition-colors ${
                activeTab === tab 
                  ? 'text-gold border-b-2 border-gold' 
                  : 'text-gray-500 hover:text-gold'
              }`}
              onClick={() => setActiveTab(tab)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
              transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
            >
              {tab}
            </motion.button>
          ))}
        </motion.div>
        
        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          {filteredProducts.map((product, index) => (
            <AnimatedProductCard key={product.id} product={product} index={index} />
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
 